import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Team from './Team';
import Organization from './Organization';

import $ from 'jquery';
import SupportTeamSettings from './SupportTeamSettings';

class TeamSetting extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/team-setting";
            var path1 = window.origin + "/platform/projectmgmt/team-setting/";
            if (currentPath === path || currentPath === path1) {
                $("#team-subtab").addClass('active');
            } else if (currentPath.includes('/projectmgmt/team-setting/support-team')) {
                $("#support-team-subtab").addClass('active');
            } $("#team-subtab,#org-tab,#support-team-subtab")
                .on("click", function () {
                    $("#team-subtab,#org-tab, #support-team-subtab")
                        .removeClass('active');
                    localStorage.setItem("last-used-team-settings-sub-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (

            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="./assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />

                    <div className="container-fluid" style={{ marginLeft: '0px' }} >
                        {/* Nav tabs */}
                        <div className="tab-class">
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/team-setting" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="team-subtab">
                                        Development Team
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/team-setting/support-team" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="support-team-subtab">
                                        Support Team
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/team-setting/support-team" component={SupportTeamSettings}></Route>
                    <Route path="/projectmgmt/team-setting" component={Team}></Route>
                </Switch>
            </div>

        );
    }
}
export default TeamSetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/team/TeamSetting.js